// src/utils/i18nRouting.js
import { SUPPORTED_LANGS } from "../config/i18n";
import { DEFAULT_LANG } from "../config/i18n";

export function buildLangPath(pathname, targetLang) {
  // /sl/about-us  -> ["sl","about-us"]
  const segments = pathname.replace(/^\/+/, "").split("/");

  // if first segment is a supported language, replace it
  if (segments.length && SUPPORTED_LANGS.includes(segments[0])) {
    segments[0] = targetLang;
  } else {
    // no lang in path, just prefix it
    segments.unshift(targetLang);
  }

  return `/${segments.join("/") || DEFAULT_LANG}`;
}
